import React from 'react';
import { StanModal } from '@/components';
import { configSettings } from '@/lib/config';

interface UsernameChangeModalProps {
    isOpen: boolean;
    newUsername: string;
    isLoading: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export const UsernameChangeModal: React.FC<UsernameChangeModalProps> = ({
    isOpen,
    newUsername,
    isLoading,
    onClose,
    onConfirm,
}) => {
    const noHttpsDomain = configSettings.noHttpsFrontDomain || 'stan.store/';
    const storeLink = `${noHttpsDomain}${newUsername}`;
    const affiliateLink = `join.${noHttpsDomain}${newUsername}`;

    return (
        <StanModal
            id='username-update-warning'
            isOpen={isOpen}
            title="Let's confirm!"
            onClose={onClose}
            primaryActionLabel='Update'
            primaryActionLoading={isLoading}
            onPrimaryAction={onConfirm}
            size='sm'
            className='py-4'
        >
            <p className='text-gray text-body-md max-md:text-body-sm mb-8 text-center'>
                You&apos;re about to change your username.
                <br />
                Make sure to update your Stan Store URL and your Affiliate Link:
            </p>

            <div className='mb-8 space-y-4'>
                <div className='text-label-sm-bold md:text-label-md-bold text-center'>
                    <p className=''>Stan Store</p>
                    <p className='text-brand-main font-medium'>{storeLink}</p>
                </div>

                <div className='text-label-sm-bold md:text-label-md-bold text-center'>
                    <p className=''>Affiliate Link</p>
                    <p className='text-brand-main font-medium'>{affiliateLink}</p>
                </div>
            </div>
        </StanModal>
    );
};
